<template>
  <div class="container-list">
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <!-- <div class="btn" @click="showDia = true" v-if="area_account!=='1'"  >
          <i class="icon-tr-search"  ></i>查询
        </div> -->

        <div class="btn-box" v-hasPermi="['troble:troble:add']">
          <div class="btn ml10" @click="showDia = true">
            <i class="icon-tr-search"></i>查询
          </div>

          <div class="btn ml10" @click="addList()">
            <i class="icon-tr-newly-added"></i>新增
          </div>
        </div>
      </div>
      <div class="common-page common-list">
        <el-table :data="list" class="">
          <el-table-column
            prop="user_name"
            label="上报人员"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="user_code"
            label="上报账号"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            prop="content"
            align="center"
            label="检查内容"
          ></el-table-column> -->
          <el-table-column
            prop="problems"
            align="center"
            label="问题隐患"
          ></el-table-column>
          <el-table-column
            prop="commit_time"
            align="center"
            label="上报时间"
          ></el-table-column>
          <el-table-column
            prop="update_time"
            align="center"
            label="整改时间"
          ></el-table-column>
          <el-table-column prop="tr_user_phone" align="center" label="状态">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                plain
                v-if="scope.row.states == 1"
                >{{ $map.wenwudanger[scope.row.states] }}</el-button
              >
              <el-button size="mini" type="danger" v-else plain>{{
                $map.wenwudanger[scope.row.states]
              }}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="getDangerDT(scope.row)"
                v-hasPermi="['troble:troble:detail']"
                >详情</el-button
              >
              <!-- <el-popconfirm
                v-if="scope.row.status == 1"
                title="确定禁用单位记录吗？"
                class="cursor"
                @onConfirm="changeStatus(scope.row, 0)"
                @confirm="changeStatus(scope.row, 0)"
              >
                <a slot="reference" class="red">
                  <el-button size="mini" type="danger" plain>删除</el-button>
                </a>
              </el-popconfirm>
              <el-popconfirm
                v-if="scope.row.status == 0"
                title="确定启用此单位吗？"
                class="cursor"
                @onConfirm="changeStatus(scope.row, 1)"
                @confirm="changeStatus(scope.row, 1)"
              >
                <a slot="reference">
                  <el-button type="primary" size="mini">开启</el-button>
                </a>
              </el-popconfirm> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :page-size="10"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 安全隐患详情 -->
    <el-dialog
      width="50%"
      :title="dt_company ? '隐患详情' : '新增隐患'"
      :visible.sync="dangerDia"
      :close-on-click-modal="false"
      :modal="false"
    >
      <el-form ref="form" :model="dangerDt" label-width="110px">
        <el-form-item v-if="dt_company" label="上报人员:" inline-message>
          <el-col>
            <!-- <el-input type="text" v-model="dangerDt.user"></el-input> -->
            <span>{{ dangerDt.user_name }}</span>
          </el-col>
        </el-form-item>
        <el-form-item v-if="dt_company" label="上报账号:" inline-message>
          <el-col>
            <!-- <el-input type="text" v-model="dangerDt.user_code"></el-input> -->
            <span>{{ dangerDt.user_code }}</span>
          </el-col>
        </el-form-item>
        <!-- <el-form-item  label="检查内容:" inline-message>
          <el-col>
            <el-input v-if="editable" type="textarea" v-model="dangerDt.content"></el-input>
            <span v-else>{{dangerDt.content}}</span>
          </el-col>
        </el-form-item> -->
        <el-form-item label="问题隐患:" inline-message>
          <el-col>
            <el-input
              type="textarea"
              v-hasPermi="['basic:yinhuan:edit']"
              v-if="editable"
              v-model="dangerDt.problems"
            ></el-input>
            <span v-else>{{ dangerDt.problems }}</span>
          </el-col>
        </el-form-item>
        <el-form-item v-if="dt_company" label="上报时间:" inline-message>
          <el-col>
            <!-- <el-input type="text" v-model="dangerDt.commit_time"></el-input> -->
            <span>{{ dangerDt.commit_time }}</span>
          </el-col>
        </el-form-item>

        <el-form-item v-if="dt_company" label="整改时间:" inline-message>
          <el-col>
            <!-- <el-input type="text" v-model="dangerDt.update_time"></el-input> -->
            <span>{{ dangerDt.update_time }}</span>
          </el-col>
        </el-form-item>
        <el-form-item v-if="dt_company" label="整改状态:" inline-message>
          <el-col>
            <el-select
              v-model="dangerDt.states"
              v-hasPermi="['basic:yinhuan:edit']"
              v-if="editable"
            >
              <el-option :value="0" label="待整改"></el-option>
              <el-option :value="1" label="已整改"></el-option>
            </el-select>
            <span v-else>{{ $map.wenwudanger[dangerDt.states] }} </span>
          </el-col>
        </el-form-item>
        <el-form-item label="现场图片:" inline-message>
          <el-col>
            <el-upload
              action="#"
              :before-upload="beforeUpload"
              :http-request="upload"
              list-type="picture-card"
              :file-list="fileList"
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  alt=""
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>

                  <span
                    v-if="editable"
                    v-hasPermi="['basic:yinhuan:edit']"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </el-col>
        </el-form-item>
      </el-form>
      <div
        class="flex center"
        v-hasPermi="['basic:yinhuan:edit']"
        v-if="editable"
      >
        <div
          class="l-btn"
          v-hasPermi="['troble:troble:update']"
          @click="onSubmit"
        >
          保存
        </div>
        <div class="l-btn ml20" @click="dangerDia = false">返回</div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" width="60%" :modal="false">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm1"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm1"
      >
      </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit1" size="small"
          >确定</el-button
        >
        <el-button @click="reset" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OSS from "ali-oss";

export default {
  data() {
    return {
      list: [],
      dialogVisible: false, // 预览图片
      fileList: [],
      nowImage: [], // 当前图片存放
      dialogImageUrl: "",
      editable:
        this.$store.state.user.permissions.indexOf("troble:troble:add") > -1 ||
        (this.$store.state.user.permissions.indexOf("*:*:*") > -1 &&
          this.$route.query.id), // 是否可编辑
      area_account: "",
      params: {
        page: 1,
        c_company_num: this.c_num,
        userName: "",
        problems: "",
      },
      dangerDt: {}, // 安全隐患
      total: 0,
      dt_company: "",
      showDia: false,
      dangerDia: false,
      dangerForm: {},
      searchForm: this.$getForm("unitSearch"),
      searchForm1: this.$getForm("fireHazards"),
      editData: {},
      remoteFuncs: {},
      showDia: false,
    };
  },
  props: ["c_num"],
  watch: {
    c_num(val) {
      if (val) {
        this.params.c_company_num = val;
        this.getList();
      }
    },
    dangerDia(val) {
      if (!val) {
        this.resetDanger();
      }
      if (val) {
        setTimeout(() => {
          var divs = document.getElementsByClassName("el-upload--picture-card");

          divs[0].style.display = this.editable ? "block" : "none";
        }, 1);
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    beforeUpload(file) {
      console.log(file);

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt2M;
      // } else {
      //   this.$message.error("请上传jpg、png、jpeg格式的图片");
      // }
    },
    reset() {
      this.showDia = false;
      // this.resetSearch();
    },
    searchSubmit1() {
      console.log(1);
      this.$refs.searchForm1
        .getData()
        .then((data) => {
          log(data);
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    //新增安全隐患
    addList() {
      (this.dangerDt = {
        content: "",
        images: "",
        problems: "",
        update_time: "",
        c_company_num: this.$route.query.id,
      }), // 安全隐患
        (this.dangerDia = true);
    },
    handleRemove(file) {
      this.fileList.map((item, index) => {
        if (item.uid == file.uid) {
          this.fileList.splice(index, 1);
          this.nowImage.splice(this.nowImage.indexOf(item.url), 1);
        }
      });
    },
    onSubmit() {
      this.dangerDt.images = this.nowImage.join(",");
      // console.log(this.dangerDt.images, this.nowImage, "this.dangerDt.images");
      var url = this.dt_company ? "/troble/trobleupdate" : "/troble/trobleadd";
      this.$post(url, this.dangerDt).then((res) => {
        // this.$message.success("保存成功");
        this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
        this.dangerDia = false;
        this.getList();
      });
    },
    resetDanger() {
      this.fileList = [];
      this.dangerDt = {};
      this.nowImage = [];
      this.dt_company = "";
    },

    areaChange(val) {
      this.params.area = val[2];
    },
    // 图片预览

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    upload(val) {
      let file = val.file;
      let fileName = file.name.toLowerCase();
      console.log(fileName, 2222222);
      if (
        !(
          fileName.indexOf("jpg") > -1 ||
          fileName.indexOf("png") > -1 ||
          fileName.indexOf("jpeg") > -1
        )
      ) {
        this.$notify({
          title: "请上传jpg、png、jpeg格式的图片",
          // message: `${_this.fileList[id].name}上传完成`,
          type: "warning",
        });

        return;
      }
      // if (!(fileName.indexOf("jpg") > -1 || fileName.indexOf('png')>-1 || fileName.indexOf('jpeg')>-1)) {
      //   this.$message.error("请上传jpg、png、jpeg格式的图片");
      //   return
      // }

      let id = Date.now() + "s" + file.size + "/" + file.name;
      this.$set(this.fileList, id, {
        name: file.name,
        size: file.size,
        uploading: true,
        time: 0,
        progress: 0,
        key: id,
        url: "",
        // client: client,
      });
      // log(this.fileList,'111111111111111111111')

      let formData = new FormData();
      // console.log(formData, "formData");
      formData.append("file", file);
      console.log(formData, "formData1");
      // formData.append("title", this.title);
      // this.getTimes(file, id);
      // console.log(file, "file");

      this.$post("/common/upload", formData).then((res) => {
        console.log(res, "res");
        this.fileList[id].progress = 100;
        this.fileList[id].uploading = false;
        this.fileList[id].url = res.data.url;

        this.$notify({
          title: "上传成功",
          message: `${this.fileList[id].name}上传完成`,
          type: "success",
        });
        // this.form.image_name = `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.fileName}`

        this.fileList.push({
          name: this.fileList[id].name,
          url: this.fileList[id].url,
        });
        this.nowImage.push(this.fileList[id].url);
        // var stobj = {tr_task_id:this.uuid,tr_baogao_address,tr_sub_status:1,tr_shengcheng_status:1,tr_baogao_xingshi:0}
        // this.$post('/api-b/tr/plan/baogaoaddress',stobj).then(data=>{
        //     console.log('zoule');
        //     this.getList()
        // })
      });

      // console.log(val, "chufa 了吗");
      //   return
      // let client = new OSS(this.$bus.config.ossConfig);
      // let file = val.file;
      // let _this = this;
      // let id =
      //   this.$bus.config.wenwu +
      //   "/t" +
      //   Date.now() +
      //   "s" +
      //   file.size +
      //   "/" +
      //   file.name;
      // this.$set(this.fileList, id, {
      //   name: file.name,
      //   size: file.size,
      //   uploading: true,
      //   time: 0,
      //   progress: 0,
      //   key: id,
      //   // client: client,
      // });
      // console.log(this.fileList, "this.fileList");
      // // _this.getTimes(file, id)

      // // 定义上传方法。
      // function multipartUpload() {
      //   _this.fileList[id].client
      //     .multipartUpload(id, file, {
      //       checkpoint: _this.fileList[id] ? _this.fileList[id].data : null,
      //       progress: (p, checkpoint, res) => {
      //         //log(p,checkpoint,res)
      //         if (checkpoint) {
      //           _this.fileList[id].progress = p * 100;
      //           _this.fileList[id].data = checkpoint;
      //         }
      //       },
      //       partSize: 1000 * 1024, //设置分片大小
      //       timeout: 120000, //设置超时时间
      //       mime: val.type,
      //     })
      //     .then((res) => {
      //       _this.fileList[id].progress = 100;
      //       _this.fileList[id].uploading = false;
      //       // _this.$notify({
      //       //   title: "上传成功",
      //       //   message: `${_this.fileList[id].name}上传完成`,
      //       //   type: "success",
      //       // });
      //       // _this.form.image_name = `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`

      //       _this.fileList.push({
      //         name: _this.fileList[id].name,
      //         url: `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`,
      //       });
      //       _this.nowImage.push(
      //         `http://zhidui-video.oss-cn-qingdao.aliyuncs.com${res.name}`
      //       );
      //       // var stobj = {tr_task_id:_this.uuid,tr_baogao_address,tr_sub_status:1,tr_shengcheng_status:1,tr_baogao_xingshi:0}
      //       // _this.$post('/api-b/tr/plan/baogaoaddress',stobj).then(data=>{

      //       //     _this.getList()
      //       // })
      //     })
      //     .catch((err) => {
      //       if (
      //         err.code == "RequestError" ||
      //         err.code == "ConnectionTimeoutError"
      //       ) {
      //         //网络错误或超时
      //         setTimeout(multipartUpload, 3000);
      //       }
      //     });
      // }

      // multipartUpload();
    },

    canclesub() {
      this.showDia = false;
      this.resetForms();
      this.getList();
    },

    getList() {
      this.$post("/troble/troblelist", this.params)
        .then((res) => {
          this.total = res.count;
          this.list = res.list;
          this.area_account = res.area_account;
        })
        .catch((err) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    // 获取隐患详情

    getDangerDT(it) {
      this.dangerDt = {};
      this.dangerDia = true;
      this.dt_company = it.uuid;
      this.getDanger();
    },
    //获取请求详情
    getDanger() {
      this.$post("troble/trobledetail", { uuid: this.dt_company }).then(
        (res) => {
          this.dangerDt = res.data;
          this.nowImage = res.data.images ? res.data.images.split(",") : [];
          this.nowImage.map((item, index) => {
            this.fileList.push({ name: "图片" + index, url: item });
          });
        }
      );
    },

    searchSubmit() {
      // this.$refs.searchForm
      //   .getData()
      //   .then((data) => {
      //     //log(data)
      //     this.params = { ...this.params, ...data };
      //     this.getList();
      //     this.showDia = false;
      //   })
      //   .catch((e) => {});
      this.params.c_belong_profession = String(this.params.c_belong_profession);
      this.params.page = 1;

      this.getList(this.params);
      this.showDia = false;
    },
    resetForms() {
      this.params = {
        page: 1,
        c_number: "",
        c_name: "",
        c_address: "",
        c_belong_profession: "",
        c_belong_profession: "",
        area: "",
      };
      this.areaValue = [];
    },
    resetSearch() {
      // this.$refs.searchForm.reset();
      // this.params = { page: 1, limit: 10, ...this.$refs.searchForm.models };
      this.resetForms();
      this.getList();
    },
  },
};
</script>

<style scoped>
.container-list {
  margin-top: 20px;
}
</style>
